import utils from '../../js/utils.js'
function *generate () {
    let id = 0
    while(id < 1000) {
        yield id++
    }
    return id
}
const iterator = generate()
const state = {
    // menu: [
    //     {
    //         menuId: iterator.next().value,
    //         selectedIcon: "merchant-a.png",
    //         title: "数据台",
    //         unselectedIcon: "merchant.png",
    //         url: '/databoard'
    //     },
    //     {
    //         menuId: iterator.next().value,
    //         selectedIcon: "merchant-a.png",
    //         title: "用户管理",
    //         unselectedIcon: "merchant.png",
    //         children: [
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "用户列表",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/user/list'
    //             },
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "销售员列表",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/user/sell'
    //             },
    //         ]
    //     },
    //     {
    //         menuId: iterator.next().value,
    //         selectedIcon: "merchant-a.png",
    //         title: "服务订单管理",
    //         unselectedIcon: "merchant.png",
    //         children: [
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "到店订单",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/appoint/storeorder'
    //             },
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "上门订单",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/appoint/serviceorder'
    //             },
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "订单评价",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/appoint/evaluate'
    //             },
    //         ]
    //     },
    //     {
    //         menuId: iterator.next().value,
    //         selectedIcon: "merchant-a.png",
    //         title: "服务管理",
    //         unselectedIcon: "merchant.png",
    //         children: [
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "服务列表",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/service/list'
    //             },
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "分类管理",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/service/type'
    //             },
    //         ]
    //     },
    //     {
    //         menuId: iterator.next().value,
    //         selectedIcon: "merchant-a.png",
    //         title: "商城管理",
    //         unselectedIcon: "merchant.png",
    //         children: [
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "订单管理",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/shop/order'
    //             },
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "订单评价",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/shop/evaluate'
    //             },
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "商品管理",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/shop/goodlist'
    //             },
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "分类管理",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/shop/type'
    //             },
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "规格管理",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/shop/spec'
    //             },
    //         ]
    //     },
    //     {
    //         menuId: iterator.next().value,
    //         selectedIcon: "merchant-a.png",
    //         title: "门店信息管理",
    //         unselectedIcon: "merchant.png",
    //         children: [
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "门店列表",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/store/list'
    //             },
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "优惠券管理",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/store/couponlist'
    //             },
    //         ]
    //     },
    //     {
    //         menuId: iterator.next().value,
    //         selectedIcon: "merchant-a.png",
    //         title: "健康师管理",
    //         unselectedIcon: "merchant.png",
    //         children: [
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "健康师列表",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/health/list'
    //             },
    //         ]
    //     },
    //     {
    //         menuId: iterator.next().value,
    //         selectedIcon: "merchant-a.png",
    //         title: "品牌商管理",
    //         unselectedIcon: "merchant.png",
    //         children: [
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "品牌商列表",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/planet/index'
    //             },
    //         ]
    //     },
    //     {
    //         menuId: iterator.next().value,
    //         selectedIcon: "merchant-a.png",
    //         title: "积分中心",
    //         unselectedIcon: "merchant.png",
    //         children: [
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "积分兑换订单",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/integral/order'
    //             },
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "积分商品管理",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/integral/good'
    //             },
    //         ]
    //     },
    //     {
    //         menuId: iterator.next().value,
    //         selectedIcon: "merchant-a.png",
    //         title: "加盟合作",
    //         unselectedIcon: "merchant.png",
    //         children: [
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "申请列表",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/partner/list'
    //             },
    //         ]
    //     },
    //     {
    //         menuId: iterator.next().value,
    //         selectedIcon: "merchant-a.png",
    //         title: "发票中心",
    //         unselectedIcon: "merchant.png",
    //         children: [
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "申请列表",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/invoice/list'
    //             },
    //         ]
    //     },
    //     {
    //         menuId: iterator.next().value,
    //         selectedIcon: "merchant-a.png",
    //         title: "充值卡管理",
    //         unselectedIcon: "merchant.png",
    //         children: [
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "充值卡列表",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/card/list'
    //             },
    //         ]
    //     },
    //     {
    //         menuId: iterator.next().value,
    //         selectedIcon: "merchant-a.png",
    //         title: "消息通知",
    //         unselectedIcon: "merchant.png",
    //         children: [
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "消息列表",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/message/index'
    //             },
    //         ]
    //     },
    //     {
    //         menuId: iterator.next().value,
    //         selectedIcon: "merchant-a.png",
    //         title: "财务明细",
    //         unselectedIcon: "merchant.png",
    //         children: [
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "门店数据",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/finance/shopdata'
    //             },
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "财务明细",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/finance/bill'
    //             },
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "提现申请",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/finance/withdraw'
    //             },
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "上门服务费用",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/finance/cityprice'
    //             },
    //         ]
    //     },
    //     {
    //         menuId: iterator.next().value,
    //         selectedIcon: "merchant-a.png",
    //         title: "系统管理",
    //         unselectedIcon: "merchant.png",
    //         children: [
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "员工管理",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/system/employee'
    //             },
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "角色权限管理",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/system/role'
    //             },
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "操作日志",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/system/log'
    //             },
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "关于我们信息",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/system/about'
    //             },
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "用户反馈",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/system/feedback'
    //             },
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "用户协议和帮助文档",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/system/help'
    //             },
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "版本管理",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/system/version'
    //             },
    //             {
    //                 menuId: iterator.next().value,
    //                 selectedIcon: "merchant-a.png",
    //                 title: "运营广告",
    //                 unselectedIcon: "merchant.png",
    //                 url: '/system/ad'
    //             },
    //         ]
    //     },
    // ],
    menu: (() => {
        try {
            let entry = localStorage.getItem('entryMenu')
            entry = utils.Decrypt(entry)
            return entry
        } catch (e) {
            console.error('菜单载入失败')
            return [
            ]
        }
    })(),
}
const getters = {
    getMenu(state) {
        return state.menu
    },
    getUrlList(state) {
        console.log(state)
        return Array.from(new Set(state.menu.flatMap(item => {
            if (item.children.length) {
                return item.children.map(item => item.url)
            }
            return item.url
        }).map(item => item.replace(/\/[0-9]+/g, ''))))
    }
}
const mutations = {
    setMenuList(state, value) { // 设置存储侧栏数据
        state.menu = value;
        localStorage.setItem('entryMenu', utils.Encrypt(JSON.stringify(value)));
    },
    
}

const actions = {
    checkPermission({ state, getters, commit }, to) {
        if (to.meta.tab) {
            return getters.getUrlList.includes(to.meta.tab.replace(/\/:\w+/g, ''))
        }
        return true
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}